export class WhatsappIcon {
  whatsappLink: string;

  constructor(phone: string, msg: string) {
    const encodedMessage = encodeURIComponent(msg);
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isWindows = /Win/i.test(navigator.userAgent);

    if (isMobile) {
      this.whatsappLink = `https://wa.me/${phone}?text=${encodedMessage}`;
    } else if (isWindows) {
      this.whatsappLink = `https://web.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;
    } else {
      this.whatsappLink = `https://api.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;
    }
  }
}
